export const fmtEUR = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", useGrouping: "always" }).format(n ?? 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const ASSET_TYPES = ["Banco", "Tarjeta", "Revolut", "Wise", "Efectivo", "Criptomonedas", "Binance", "Coinbase", "eToro", "Cuentas por cobrar", "Otros"];

export const INCOME_CATEGORIES = ["Nómina GU", "Nómina JA", "Natur", "Otros"];

export const EXPENSE_CATEGORIES = [
  "Vivienda", "Suministros", "Telecomunicaciones", "Colegio", "Supermercado",
  "Transporte", "Salud", "Ocio", "Autoescuela", "Financieros", "Otros",
];
